import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchSgdPostsAsync } from "../../../../../redux/thunk/Posts";
import ReusableList from "../../ReusableList";

function List() {
  const { sgdPosts, sgdStatus } = useSelector((state) => state.posts);
  console.log(sgdPosts, "sgdPosts");

  const dispatch = useDispatch();
  let [page, setPage] = useState(1);
  let [searchValue, setSearchValue] = useState("");
  let [changeStatus, setChangeStatus] = useState(false);

  let postPath = "posts-sgd?page=" + page;
  let searchPath =
    "search-post-by-name?page=" + page + "&q=" + searchValue + "&category=sgd";
  const [isSearch, setIsSearch] = useState(false);
  useEffect(() => {
    if (searchValue !== "") {
      setIsSearch(true);
    } else {
      dispatch(fetchSgdPostsAsync(postPath));
      setIsSearch(false);
    }
    setChangeStatus(false);
  }, [dispatch, postPath, page, searchValue, searchPath, changeStatus]);

  let handleChange = (event, p) => {
    setPage(p);
  };

  function handleReload(status) {
    setChangeStatus(status);
  }

  return (
    <ReusableList
      title="Summarize Group Discussion"
      status={sgdStatus}
      posts={sgdPosts}
      path="posts-sgd"
      category="sgd"
      storage="sgd"
      audio="audio"
      isSearch={isSearch}
      searchAPI={(path) => fetchSgdPostsAsync(path)}
      searchPath={searchPath}
      handleChange={handleChange}
      page={page}
      setPage={setPage}
      setSearchValue={setSearchValue}
      handleReload={handleReload}
    ></ReusableList>
  );
}

export default List;
